import { render, staticRenderFns } from "./bottomShow.vue?vue&type=template&id=92418dca&scoped=true&"
import script from "./bottomShow.vue?vue&type=script&lang=js&"
export * from "./bottomShow.vue?vue&type=script&lang=js&"
import style0 from "./bottomShow.vue?vue&type=style&index=0&id=92418dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92418dca",
  null
  
)

export default component.exports